import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface InfoCSSStyle extends UIComponentCSSStyle
{
    getHeaderDivCSSStyle():object;
    getTitleCSSStyle():object;
    getCloseIconDivCSSStyle():object;
    getCloseIconCSSStyle():object;
    getVerifyNumberButtonCSSStyle(): object ;

    getMobileWrapperCSSStyle():object;
    getMobileTitleCSSStyle():object;
    getMobileHeaderDivCSSStyle(): object;
    getMobileCloseIconDivCSSStyle():object;
    getMobileCloseIconCSSStyle():object;
    getMobileVerifyNumberButtonCSSStyle(): object ;
}

export class InfoCSSStyleImpl extends UIComponentCSSStyleImpl implements InfoCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "584px",
            borderRadius: "8px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            paddingBottom:'30px',
        };
    }

    getHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "60px",
            display: "flex",
            flexFlow: "row wrap",
            borderRadius: "8px 8px 0px 0px",
        };
    }

    getTitleCSSStyle(): object {
        return {
            width: "89.5%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft:"100px",
            paddingRight:"60px",
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center",
        };
    }
    
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getVerifyNumberButtonCSSStyle(): object 
    {
        return {
            marginTop: "30px",
            width:'180px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }
    getCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }

    getMobileWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            paddingBottom:'30px',
        };
    }

    getMobileHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "50px",
            display: "flex",
            flexFlow: "row wrap",
            borderRadius: "8px 8px 0px 0px",
        };
    }

    getMobileTitleCSSStyle(): object {
        return {
            // width: "76%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            // paddingLeft:"100px",
            // paddingRight:"60px",
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "5px",
            textAlign: "center",
        };
    }
    
    getMobileCloseIconDivCSSStyle(): object 
    {
        return {
            height: "40px",
            // width: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getMobileVerifyNumberButtonCSSStyle(): object 
    {
        return {
            marginTop: "15px",
            width:'110px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }
    getMobileCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }

}    
   


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/info/infocss.tsx